import { AREAS, BUSINESS } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";
import { m } from "framer-motion";
import { Check } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export const ServiceArea = () => (
  <section id="areas" className="py-24 lg:py-36 bg-paper">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <Reveal>
          <h2 className="font-heading uppercase leading-[0.9] tracking-tight text-4xl sm:text-6xl text-ink">
            Covering the<br />whole of West<br />Yorkshire.
          </h2>
        </Reveal>
        <p className="mt-8 text-ink-soft leading-relaxed max-w-md">
          Based in Bradford, we work throughout the region. Not sure if we cover your postcode?
          Give us a call — we almost certainly do.
        </p>
        <a
          href={BUSINESS.phoneHref}
          data-testid="area-call-cta"
          className="mt-8 inline-flex items-center gap-2 text-brand font-medium hover:text-ink transition-colors"
        >
          Check your area — {BUSINESS.phoneDisplay}
        </a>
      </div>

      <div className="lg:col-span-7">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-line border border-line">
          {AREAS.map((area, i) => (
            <m.div
              key={area}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, ease, delay: i * 0.03 }}
              className="group flex items-center gap-2 sm:gap-3 bg-white hover:bg-paper transition-colors duration-200 px-3 sm:px-5 min-h-[72px]"
            >
              <Check className="w-4 h-4 text-brand shrink-0" strokeWidth={2.5} />
              <span className="font-heading uppercase tracking-tight text-sm sm:text-lg leading-tight text-ink whitespace-nowrap">{area}</span>
            </m.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
